var $c30474fbd65b2878$exports = {};
$c30474fbd65b2878$exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};


export {$c30474fbd65b2878$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
